import services from './services';
import {
    lg,
    cloneDeep,
    util,
    isCorrectVal,
    isDate
} from 'utils';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig, //寄送，支付接口
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';
import NProgress from 'nprogress';
import $http from '$http';
import chooseDialog from "@pages/Order/zqwOrder/components/chooseDialog/index.vue" //选择代理商弹窗
import AddressDialog from "@pages/Order/zqwOrder/components/AddressDialog/index.vue" // 选择收货地址弹窗
import addAgent from 'components/agent-add/index.vue'; //新增代理商
export default {
    mixins: [services],
    components: {
        chooseDialog,
        AddressDialog,
    },
    props: {
        value: {
            type: Boolean,
            default: null
        },
    },
    data() {
        return {
            num: 1,
            step: 1, //步数 
            UnitPrice: 11300, //11200 套餐2价格
            agent: '',
            school: '',
            options: [{
                id: 3001,
                label: '智趣坞幼教系统在线教育'
            }, {
                id: 3002,
                label: '智趣坞幼教系统在线教育2'
            }],
            PayList: [{
                "Id": 222,
                "ParmName": "寄付(送货)"
            }], //寄送方式
            transportList: [{
                "Id": 223,
                "ParmName": "物流"
            }], //支付方式
            form: this.getSubmitFormData(),
            details: {},
            AgentConsigneeList: [],
            ConsigneeList: '', //收货地址
            ConsigneeListName: '', //联系人及电话
            AddDialogVisible: false,
            showData: this.getShowData(), //弹窗传参
            PayTitle: "支付凭证单号",
            posShow: false,
            pageIndex: 1,
            pageSize: 10,
            load: false,
            minNum: 5,
            isChoose: true,

        }
    },
    methods: {
        getSubmitFormData() {
            return cloneDeep({
                "PackageId": 3001,
                "AgentId": 0,
                "ClassNum": 0,
                "OrderPrice": 0,
                "FirstOrderPrice": 0,
                "SecondOrderPrice": 0,
                "ConsigneeId": 0,
                "SendMode": 223,
                "PayMode": 222,
                "GoodsList": [],
                "OrderRemark": ''

            });
        },
        changeValue(val) {
            this.form.PackageId = val
        },
        // 获取组件chooseDialog 值
        getDialogList(item) {
            this.agent = item.Customer + '   ' + item.Address + '   ' + item.AgentTel
            this.form.AgentId = item.Id,
                this.ConsigneeList = '',
                this.ConsigneeListName = '',
                this.getAgentBookOrderHistory(this.form.AgentId, 0)
            this.getAgentConsigneeList(this.form.AgentId)
        },
        //获取选择弹窗收货地址
        getAddress(item) {
            this.ConsigneeList = item.Address
            this.ConsigneeListName = item.Consignee + '  ' + item.ConsigneeTel
            this.form.ConsigneeId = item.Id
        },
        // 选择代理商
        chooseAgent() {
            this.$refs.chooseDialog.show({
                title: '选择代理商'
            });
        },
        //选择园所收货地址
        changeAddress() {
            if (this.form.AgentId == 0) {
                this.$notify({
                    title: '警告',
                    message: '请先选择代理商',
                    type: 'warning'
                });
            } else {
                this.$refs.AddressDialog.show({
                    AgentId: this.form.AgentId
                });
            }

        },
        getShowData() {
            return cloneDeep({
                OrderId: 0,
                title: '',
                isReadOnly: false
            });
        },
        show(options) {
            this.showData.title = options.title
            this.showData.isReadOnly = options.isReadOnly //true 为查看
            this.AddDialogVisible = true;
            if (this.showData.title !== '在线教育下单') {
                this.showData.OrderId = options.OrderId
                this.isChoose = false; //修改或编辑不能选择代理商
                this.getList() //获取单条数据 
            } else {
                this.isChoose = true
                this.form = this.getSubmitFormData(),
                    this.agent = '',
                    this.ConsigneeList = '', //收货地址
                    this.ConsigneeListName = '', //联系人及电话
                    this.options = [{
                        id: 3001,
                        label: '智趣坞幼教系统在线教育'
                    }, {
                        id: 3002,
                        label: '智趣坞幼教系统在线教育2'
                    }]
            }


        },
        submit() {
            this.form.OrderPrice = this.price;
            this.form.GoodsList = []
            for (let i = 0; i < this.tableData.length; i++) {
                this.form.GoodsList.push({
                    "ProId": this.tableData[i].proId,
                    "ProNum": this.tableData[i].proNum //本期数
                })
            }
            this.form.FirstOrderPrice = this.currentPrice;
            this.form.SecondOrderPrice = this.SecondOrderPrice;
            console.log(this.form)
            // 判断
            let rule = [{
                name: "代理商",
                value: this.agent,
                required: true,
            }, {
                name: "收货地址",
                value: this.ConsigneeList,
                required: true,
            }, ]
            var flag = util.checkForm({
                ele: this,
                rules: rule
            });

            if (!flag) {
                return;
            }
            // if (this.details.ProNum >= this.details.FirstGoodsNum) {
            //     this.$notify({
            //         title: '警告',
            //         message: '该代理商的订货量已全部订购，无法继续下单,请重新选择代理商',
            //         type: 'warning'
            //     });
            //     return;
            // }
            // else if (this.details.ContractMoney == 0) {
            //     this.$notify({
            //         title: '警告',
            //         message: '该代理商合同预付款为0，无法继续下单,请重新选择代理商',
            //         type: 'warning'
            //     });
            //     return;
            // }
            // let detailsNum = this.details.FirstGoodsNum - this.details.ProNum
            // if (this.form.ClassNum > detailsNum) {
            //     this.$notify({
            //         title: '警告',
            //         message: '已超首批订货量；无法继续下单',
            //         type: 'warning'
            //     });
            //     return;
            // }
            if (this.showData.title == "修改订单") {
                this.getUpdateOrderList() //修改订单
            } else {
                this.getAddOrderList(); //新增订单
            }

        }
    },
    computed: {
        //订单价格
        price: function () {
            if (this.form.PackageId == 3001) {
                this.UnitPrice = 11300
                return this.form.ClassNum * this.UnitPrice
            } else {
                this.UnitPrice = 14000
                return this.form.ClassNum * this.UnitPrice
            }

        },
        //本期应收款=6000*班级数
        currentPrice: function () {
            if (this.form.PackageId == 3001) {
                return this.form.ClassNum * 6000
            } else {
                return this.form.ClassNum * 7000
            }
        },
        //二期应收款=5300*班级数
        SecondOrderPrice: function () {

            if (this.form.PackageId == 3001) {
                return this.form.ClassNum * 5300
            } else {
                return this.form.ClassNum * 7000
            }
        },
        tableData: function () {
            if (this.form.PackageId == 3001) {
                return [{
                    'proId': 333,
                    'proName': '55寸在线教育平台终端',
                    "proNum": this.form.ClassNum,
                }]
            } else if (this.form.PackageId == 3002) {
                return [{
                    'proId': 320,
                    'proName': '65寸在线教育平台终端',
                    "proNum": this.form.ClassNum,
                }]
            }


        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/zqwOrder/addSellingOrder/vm.js